import axios from 'axios'

export async function getFootPrintTypes(): Promise<{ data: any }> {
  const response = await axios.get('/api/v1/footprint_types/')
  return response.data
}

export async function getMyFootPrintListAPI(): Promise<{ data: any }> {
  const response = await axios.get('/api/v1/footprints/')
  return response.data
}

export async function createFootPrintAPI(payload): Promise<{ data: any }> {
  const response = await axios.post('/api/v1/footprints/', payload)
  return response.data
}

export async function updateFootPrintAPI(id: number, payload: any): Promise<{ data: any }> {
  const response = await axios.put(`/api/v1/footprints/${id}/`, payload)
  return response.data
}

export async function deleteFootPrintAPI(id: number): Promise<{ data: any }> {
  const response = await axios.delete(`/api/v1/footprints/${id}/`)
  return response.data
}

export async function getFootPrintVsCompensationDataAPI(): Promise<{ data: object }> {
  const response = await axios.get(`/api/v1/footprints/get_my_footprint_vs_my_compensation_data/`)
  return response.data
}

export async function getFootPrintHistoryAPI(): Promise<{ data: object }> {
  const response = await axios.get(`/api/v1/footprints/get_footprint_type_history/`)
  return response.data
}
